import { useCallback } from "react";
import { useNavigate, } from "react-router-dom";

const useRedirectTo = () => {
  const navigate = useNavigate();
  const handleRedirectTo = useCallback((url, data, options = {}) => {
    navigate(url, {
      state: {
        ...data
      },
      replace: options?.replace ?? false,
    })
  }, [navigate]);

  return {
    handleRedirectTo,
  };
};

export default useRedirectTo;
